"use client";

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
  MenuItem,
  Select,
  TextField,
  Grid,
  Button,
  InputLabel,
  FormControl,
  SelectChangeEvent,
  Switch,
  Checkbox,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const dayMap: Record<string, number> = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 7,
};

export default function SetRbtPage() {
  const [settingFor, setSettingFor] = useState("default");
  const [timeSetting, setTimeSetting] = useState("24 Hour");
  const [daySetting, setDaySetting] = useState("7 Days");
  const [sendSms, setSendSms] = useState(false);
  const [group, setGroup] = useState("");
  const [friend, setFriend] = useState("");
  const [date, setDate] = useState<Dayjs | null>(null);
  const [data, setData] = useState<any | null>(null);
  const [startHr, setStartHr] = useState("");
  const [endHr, setEndHr] = useState("");
  const [days, setDays] = useState<number[]>([]);
  const [rbtDetails, setRbtDetails] = useState([]);

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const rbtCode = query.get("rbtCode");
  const rbtName = query.get("rbtName");

  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );

  const { planId, subType } = useSelector((state: RootState) => state.profile);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/Content/ProfileData?msisdn=${
            countryCode + msisdn
          }&service=${process.env.REACT_APP_SERVICE}&interface=${
            process.env.REACT_APP_INTERFACES
          }&langId=${process.env.REACT_APP_LANGID}&countryCode=${countryCode}`
        );
        setData(data?.crbtProfile);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProfile();
  }, [countryCode, msisdn]);

  const getMyLibraryTones = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Profile/MyTones?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${process.env.REACT_APP_LANGID}`
    );

    setRbtDetails(res.data.crbtProfile.toneList);
  };

  const handleSetTone = async () => {
    try {
      const username = countryCode + msisdn;
      const sendInfotoFmsisdn = sendSms ? "1" : "0";

      const groupId = group || "";
      const fmsisdn = friend || "";

      const formattedDate = date ? dayjs(date).format("DD-MM-YYYY") : "";

      const finalDays = daySetting === "7 Days" ? 8 : days.join("");

      const startHourValue =
        timeSetting === "Set Time" ? Number(startHr) * 100 : 2500;

      const endHourValue =
        timeSetting === "Set Time" ? Number(endHr) * 100 : 2500;

      const data =
        "planId=" +
        planId +
        "&rbtCode=" +
        rbtCode +
        "&subType=" +
        subType +
        "&settingFor=" +
        settingFor +
        "&fmsisdn=" +
        fmsisdn +
        "&sendInfoToFmsisdn=" +
        sendInfotoFmsisdn +
        "&date=" +
        formattedDate +
        "&groupId=" +
        groupId +
        "&stHr=" +
        startHourValue +
        "&endHr=" +
        endHourValue +
        "&days=" +
        finalDays;

      const apiUrl = `${process.env.REACT_APP_API_URL}/Purchase/SetRBT?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&${data}`;

      const res = await axios.post(apiUrl);

      if(res?.data?.resCode === 231){
        alert(res?.data?.resMessage);
        navigate('/flowtone/toneSetting');
      }else {
        alert(res?.data?.resMessage)
      }

    } catch (error) {
      console.error("API Error:", error);
      alert("Failed to set tone");
    }
  };

  useEffect(() => {
    getMyLibraryTones();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Card sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
        <CardContent>
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{ borderBottom: "1px solid #ccc", pb: 1, mb: 2 }}
            textAlign="center"
          >
            FLOW TONE SETTING : {rbtName}
          </Typography>

          <Box sx={{ background: "#f0f0f0", p: 1, fontWeight: "bold", mb: 2 }}>
            Set For
          </Box>

          <Grid container spacing={2}>
            <Grid size={6}>
              <RadioGroup
                value={settingFor}
                onChange={(e) => setSettingFor(e.target.value)}
              >
                <FormControlLabel
                  value="default"
                  control={<Radio />}
                  label="Set as Default"
                  sx={{ width: "fit-content", m: 0, p: 0 }}
                />

                <FormControlLabel
                  value="Group"
                  control={<Radio />}
                  label="Group"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />

                <FormControlLabel
                  value="Friend"
                  control={<Radio />}
                  label="Friend"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
                <Box sx={{ pl: 1.5, pt: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sendSms}
                        onChange={(e) => setSendSms(e.target.checked)}
                        disabled={settingFor !== "Friend"}
                      />
                    }
                    label="Send SMS to Friend"
                  />
                </Box>

                <FormControlLabel
                  value="Date"
                  control={<Radio />}
                  label="Date"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
              </RadioGroup>
            </Grid>

            <Grid size={6}>
              <FormControl
                fullWidth
                sx={{ mb: 2, mt: 6 }}
                disabled={settingFor !== "Group"}
                size="small"
              >
                <InputLabel>Select Group</InputLabel>
                <Select
                  value={group}
                  onChange={(e) => setGroup(e.target.value)}
                  label="Select Group"
                >
                  {data?.groupList.map((item: any, index: any) => (
                    <MenuItem key={index} value={item?.groupId}>
                      {item?.groupName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                fullWidth
                sx={{ mb: 2 }}
                disabled={settingFor !== "Friend"}
                size="small"
              >
                <InputLabel>Select Friend</InputLabel>
                <Select
                  value={friend}
                  onChange={(e) => setFriend(e.target.value)}
                  label="Select Friend"
                >
                  {data?.friendList.map((item: any, index: any) => (
                    <MenuItem key={index} value={item?.fmsisdn}>
                      {item?.friendName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                fullWidth
                disabled={settingFor !== "Date"}
                size="small"
                sx={{ pt: 5 }}
              >
                <DatePicker
                  label="DD-MM-YYYY"
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                  slotProps={{ textField: { size: "small" } }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ background: "#f0f0f0", p: 1, mt: 3, fontWeight: "bold" }}>
            Time Setting
          </Box>

          <Grid container spacing={2}>
            <Grid size={6}>
              <RadioGroup
                value={timeSetting}
                onChange={(e) => setTimeSetting(e.target.value)}
                sx={{ mt: 1 }}
              >
                <FormControlLabel
                  value="24 Hour"
                  control={<Radio />}
                  label="24 Hour"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
                <FormControlLabel
                  value="Set Time"
                  control={<Radio />}
                  label="Set Time"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
              </RadioGroup>
            </Grid>
            <Grid size={6}>
              {timeSetting === "Set Time" && (
                <Grid
                  container
                  spacing={2}
                  mt={1}
                  display="flex"
                  direction="column"
                >
                  <Grid size={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Select Start hour</InputLabel>
                      <Select
                        value={startHr}
                        onChange={(e) => setStartHr(e.target.value)}
                        label="Select Start hour"
                      >
                        {Array.from({ length: 24 }).map((_, i) => (
                          <MenuItem key={i} value={i}>
                            {i}:00
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid size={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Select End Hour</InputLabel>
                      <Select
                        value={endHr}
                        onChange={(e) => setEndHr(e.target.value)}
                        label="Select End Hour"
                      >
                        {Array.from({ length: 24 }).map((_, i) => (
                          <MenuItem key={i} value={i}>
                            {i}:00
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Box sx={{ background: "#f0f0f0", p: 1, mt: 3, fontWeight: "bold" }}>
            Day Setting
          </Box>

          <Grid container spacing={2}>
            <Grid size={6}>
              <RadioGroup
                value={daySetting}
                onChange={(e) => setDaySetting(e.target.value)}
                sx={{ mt: 1 }}
              >
                <FormControlLabel
                  value="7 Days"
                  control={<Radio />}
                  label="7 Days a week"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
                <FormControlLabel
                  value="Set Days"
                  control={<Radio />}
                  label="Set Days"
                  sx={{ width: "fit-content", m: 0, p: 0, pt: 1 }}
                />
              </RadioGroup>
            </Grid>
            <Grid size={6}>
              <Typography pt={3}>All</Typography>

              <FormControl
                fullWidth
                sx={{ mt: 3 }}
                size="small"
                disabled={daySetting === "7 Days"}
              >
                <InputLabel>Select day of week</InputLabel>

                <Select<number[]>
                  multiple
                  value={days}
                  label="Select day of week"
                  onChange={(e) => {
                    const value = e.target.value;
                    setDays(
                      typeof value === "string"
                        ? value.split(",").map(Number)
                        : (value as number[])
                    );
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((num) =>
                        Object.keys(dayMap).find((k) => dayMap[k] === num)
                      )
                      .join(", ")
                  }
                >
                  {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                    (day) => (
                      <MenuItem key={day} value={dayMap[day]}>
                        {days.includes(dayMap[day]) && (
                          <CheckIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                          />
                        )}
                        {day}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box mt={4} display="flex" gap={2} justifyContent="center">
            <CustomButton
              text="Set Tone"
              sx={{ textTransform: "capitalize" }}
              onClick={handleSetTone}
            />
            <CustomButton text="Reset" sx={{ textTransform: "capitalize" }} />
            <CustomButton text="Cancel" sx={{ textTransform: "capitalize" }} />
          </Box>
        </CardContent>
      </Card>
    </LocalizationProvider>
  );
}
